import type { Scope } from './types';

/**
 * Catalogue scopes ('all' first, like the backend's SCOPE_ORDER).
 *  - all   — every record of the company
 *  - owned — records I created
 *  - added — records assigned to me / that involve me (member, assignee, team)
 *  - both  — owned OR added
 */
export const SCOPES: readonly Scope[] = ['all', 'owned', 'added', 'both'];

const SCOPE_SET: ReadonlySet<string> = new Set(SCOPES);

export function isScope(value: unknown): value is Scope {
  return typeof value === 'string' && SCOPE_SET.has(value);
}

/**
 * Does a grant at `have` cover the minimum `need`?
 * all ⊇ both ⊇ {owned, added}; owned and added don't cover each other.
 * No minimum → any grant. No grant → never.
 */
export function atLeast(have: Scope | null | undefined, need?: Scope): boolean {
  if (!have) return false;
  if (!need) return true;
  if (have === 'all') return true;
  if (need === 'all') return false;
  if (have === 'both') return true;
  return have === need;
}
